import { render, staticRenderFns } from "./AppAlertsDialogAlertDetails.vue?vue&type=template&id=9f1af8ae&scoped=true&"
import script from "./AppAlertsDialogAlertDetails.vue?vue&type=script&lang=js&"
export * from "./AppAlertsDialogAlertDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1af8ae",
  null
  
)

export default component.exports